import React from 'react';
import {Price} from './price';
import {Trans} from '@ui/i18n/trans';
import clsx from 'clsx';
import {FormattedCurrency} from '@ui/i18n/formatted-currency';

interface FormattedPriceProps {
  price?: Omit<Price, 'id'>;
  variant?: 'slash' | 'separateLine';
  className?: string;
  priceClassName?: string;
  periodClassName?: string;
}
export function FormattedPrice({
  price,
  variant = 'slash',
  className,
  priceClassName,
  periodClassName,
}: FormattedPriceProps) {
  if (!price) return null;

  const count = price.interval_count ?? 1;
  const translatedInterval =
    count > 1 ? (
      <PluralInterval interval={price.interval} count={count} />
    ) : (
      <Trans message={price.interval} />
    );

  return (
    <div className={clsx('flex items-center gap-6', className)}>
      <div className={priceClassName}>
        <FormattedCurrency value={price.amount} currency={price.currency} />
      </div>
      {variant === 'slash' ? (
        <div className={periodClassName}> / {translatedInterval}</div>
      ) : (
        <div className={periodClassName}>
          <Trans message="per" /> <br /> {translatedInterval}
        </div>
      )}
    </div>
  );
}

function PluralInterval({interval, count}: {interval: string; count: number}) {
  if (interval === 'day') {
    return (
      <Trans message="[one :count day|other :count days]" values={{count}} />
    );
  }
  if (interval === 'month') {
    return (
      <Trans
        message="[one :count month|other :count months]"
        values={{count}}
      />
    );
  }
  if (interval === 'year') {
    return (
      <Trans message="[one :count year|other :count years]" values={{count}} />
    );
  }
  return <Trans message=":count billing periods" values={{count}} />;
}
